<script>
import BrandedTextElement
  from "%/dynamic-component-editor/standard-elements/text-element/BrandedTextElement.vue";
import BrandedTextOptions from "%/dynamic-component-editor/bundles/branded-text-options";

export default {
  name: "BrandedHeadingElement",
  elementPanelSettings: {
    tags: ["text", "heading", "title", "h1"],
    alias: "Heading",
    displayName: "Text",
    displayIcon: "text",
    elementType: "element",
    elementGroup: "text",
    displayAsWysiwyg: true,
  },
  extends: BrandedTextElement,
  optionBundles: [
    new BrandedTextOptions({
      "default.text-style-option": "heading",
    }),
  ],
};
</script>
